import { ChangeDetectorRef, Directive, Input, OnInit } from "@angular/core";
import { Entity, Validator } from "breeze-client";
import { DxiValidatorValidationRuleComponent } from "devextreme-angular/ui/validator";

@Directive({
    selector: "dxi-validator-validation-rule[adaptEntity][adaptBreezeValidator]",
    standalone: false,
})
export class BreezeValidationRuleDirective implements OnInit {
    @Input("adaptEntity") public entity?: Entity;
    @Input("adaptBreezeValidator") public validator?: Validator;

    public constructor(
        private dxValidationRuleComponent: DxiValidatorValidationRuleComponent,
        private changeDetector: ChangeDetectorRef,
    ) {
        if (!this.dxValidationRuleComponent) {
            throw new Error("DxValidationRuleComponent is undefined! Has the version of DX or Angular changed?");
        }
    }

    public ngOnInit() {
        this.dxValidationRuleComponent.type = "custom";
        this.dxValidationRuleComponent.validationCallback = (event: any) => {
            if (!this.entity || !this.validator) {
                event.rule.message = "You should specify the entity and validator to validate";
                return false;
            }

            event.rule.message = this.validator.getMessage();

            this.entity.entityAspect.validateEntity();
            const hasError = this.entity.entityAspect.getValidationErrors()
                .some((e) => e.validator === this.validator);
            return !hasError;
        };

        // We must do this since we updated the component properties dynamically
        this.changeDetector.markForCheck();
    }
}
